/** @jsxImportSource @emotion/react */

import React from 'react';
import { css } from '@emotion/react';
import { connect } from 'unistore/react';

import { Button } from '@components';
import YoutubeBtn from '../../components/Button/youtubeBtn';

import { sidebarActions } from '@utils/store/actions';

export const LinkItem = ({ title, type, text, link, close, video }) => {
	switch (type) {
		case 0:
			return (
				<Button
					href={`https://bitbns.com/trade/#${link}`}
					onClick={close}
					variant="minimal"
					triangle="right"
					size="tiny"
					className="mr-4 mb-4"
				>
					{text}
				</Button>
			);
		case 2:
			return (
				<YoutubeBtn
					onClick={close}
					variant="minimal"
					triangle="right"
					size="tiny"
					videoId={video}
					modalText={title}
					text={text}
					className="mr-4 mb-4"
				/>
			);
		default:
			return (
				<Button
					target="_blank"
					rel="noreferrer noopener nofollow"
					href={link}
					onClick={close}
					variant="minimal"
					triangle="right"
					size="tiny"
					className="mr-4 mb-4"
				>
					{text}
				</Button>
			);
	}
};

export const bubbleStyle = css`
	display: inline-flex;
	margin-left: 10px;
	transform: none !important;
	border-radius: 20px;
	background: #ff5746;
	color: white;
	width: 16px;
	height: 16px;
	font-size: 11px;
	align-items: center;
	justify-content: center;
	animation: slideInDown ease-out 0.3s;
	position: absolute;
	letter-spacing: 0px;
`;

export const headingStyle = css`
	position: sticky;
	top: 44px;
	box-shadow: 0 2px 3px -2px rgba(0, 0, 0, 0.2);
	z-index: 2;
	background: rgb(242, 242, 242);
`;

export const alertColors = new Map([
	[
		-2,
		{
			bg: 'bg-pastelRed',
			text: 'text-redOrangified',
			color: '#c0392b',
		},
	],
	[
		-1,
		{
			bg: 'bg-redLighter',
			text: 'text-darkSalmon',
			color: '#e74c3c',
		},
	],
	[
		0,
		{
			bg: 'bg-deepPeach',
			text: 'text-dharkyBhicky',
			// color: '#F4977C',
			color: 'transparent',
		},
	],
	[
		1,
		{
			bg: 'bg-lightSeaGreen',
			text: 'text-primary',
			color: '#1abc9c',
		},
	],
]);

export const AlertMsg = connect(
	'',
	sidebarActions
)(
	React.memo(({ icon, title, alertType, text, links, __closeSideNotifs }) => {
		if (alertType === -128) {
			return null;
		}

		return (
			<li className="bb-notification__notifLi py-8 px-8 flex bg-white items-start shadow-inner hover:shadow-none">
				<img
					src={icon}
					alt={title}
					height="30"
					width="30"
					className="mr-2"
				/>
				<div className="flex-grow">
					<div className="flex items-center justify-start relative">
						<div className="leading-none ml-2 flex-grow flex-shrink-0 flex items-center justify-between">
							<span
								className={`font-bold ${
									alertColors.get(alertType).text
								}`}
							>
								{title}
							</span>
						</div>
					</div>
					<p className="leading-normal my-2 ml-2">{text}</p>

					{links.length > 0 && (
						<div className="mt-4 ml-2">
							{links.map(link => (
								<LinkItem
									{...link}
									close={__closeSideNotifs}
									title={text}
									key={`${link.text}-${link.link}`}
								/>
							))}
						</div>
					)}
				</div>
			</li>
		);
	})
);
